import { SceneView } from "./SceneView"
import { SceneFrame } from "../Components/Scene"

export interface ConceptSceneViewProps {
  onClose?: () => void;
}

export const conceptFrames: SceneFrame[] = [
  {
    animations: ["auto-show-overlay"],
    content: "start",
    contentOptions: { theme: "dark" },
    name: "start1",
    overlayPosition: "hide",
  },
  {
    content: "start",
    name: "start2",
    overlayPosition: "center",
  },
  {
    content: "timeline",
    name: "timelineOverview",
    overlayPosition: "center-right",
  },
  {
    animations: ["scroll-up-down"],
    content: "timeline",
    name: "timelineYears",
    overlayPosition: "center-right",
  },
  {
    animations: ["scroll-up-down"],
    content: "timeline",
    name: "timelineYears2",
    overlayPosition: "center-right",
  },
  {
    animations: [
      "show-pointer",
      "scroll-to-highlight",
    ],
    content: "timeline",
    highlight: ".CruiseCalendarView-year.year-2024 .CruiseCalendarView-month.month-6 .marker",
    name: "timelineYears3",
    overlayPosition: "center-right",
  },

  {
    animations: ["show-pointer"],
    content: "timeline",
    highlight: ".CruiseCalendarView-year.year-2024 .CruiseCalendarView-month.month-4",
    name: "timelineYears4",
    overlayPosition: "center-right",
  },
  {
    action: {
      action: "click",
      selector: ".CruiseCalendarView-cruise[data-cruise-id='9']",
    },
    animations: [
      "show-action-click",
      "scroll-to-highlight",
    ],
    content: "timeline",
    highlight: ".CruiseCalendarView-cruise[data-cruise-id='9']",
    name: "timelineVoyageClick",
    overlayPosition: "center-right",
  },
  {
    animations: ["scroll-to-top"],
    highlight: ".CruiseView-title",
    content: "cruise",
    name: "timelineVoyage1",
    overlayPosition: "center-right",
  },
  {
    animations: ["scroll-up-down"],
    content: "cruise",
    name: "timelineVoyage2",
    overlayPosition: "center-right",
  },
  {
    action: {
      action: "click",
      selector: ".CruiseView .DetailsToggle",
    },
    animations: [
      "scroll-to-top",
      "show-action-click",
      "scroll-to-highlight",
    ],
    content: "cruise",
    name: "timelineVoyage3",
    overlayPosition: "center-right",
  },
  {
    content: "cruise-details",
    highlight: ".CruiseView-details .TabBar-tab:nth-child(1)",
    name: "timelineVoyage4",
    overlayPosition: "center-right",
  },
  {
    content: "cruise-details-stats",
    highlight: ".CruiseView-details .TabBar-tab:nth-child(2)",
    name: "timelineVoyage5",
    overlayPosition: "center-right",
  },
  {
    content: "cruise-details-track",
    highlight: ".CruiseView-details .TabBar-tab:nth-child(3)",
    name: "timelineVoyage6",
    overlayPosition: "center-right",
  },
  {
    animations: [
      "scroll-to-top",
      "show-pointer",
    ],
    content: "cruise-details-track",
    highlight: ".CruiseView .CloseButton",
    name: "timelineVoyage7",
    overlayPosition: "center-right",
  },
  {
    action: {
      action: "click",
      selector: ".CruiseView .DetailsToggle",
    },
    animations: [
      "scroll-to-top",
      "show-action-click",
    ],
    content: "cruise-details-track",
    name: "timelineVoyage8",
    overlayPosition: "center-right",
  },
  {
    content: "cruise",
    highlight: ".TripView-header[data-trip-id='1']",
    name: "timelineVoyage9",
    overlayPosition: "center-right",
  },
  {
    content: "cruise",
    highlight: ".TripView[data-trip-id='1']",
    name: "timelinePassage1",
    overlayPosition: "center-right",
  },
  {
    action: {
      action: "click",
      selector: ".TripView[data-trip-id='1'] .TripView-details-toggle",
    },
    animations: [
      "show-action-click",
    ],
    content: "cruise-stats",
    highlight: ".TripView-details .TabBar-tab:nth-child(2)",
    name: "timelinePassage2",
    overlayPosition: "center-right",
  },
  {
    action: {
      action: "click",
      selector: ".DayView[data-day-id='6'] .DayView-date",
    },
    animations: [
      "show-action-click",
    ],
    content: "cruise-stats",
    highlight: ".DayView[data-day-id='6']",
    name: "timelinePassage3",
    overlayPosition: "center-right",
  },
  {
    animations: [
      "scroll-highlight-top",
    ],
    content: "day",
    highlight: ".DayView[data-day-id='6'] .DayHeaderView",
    name: "timelineDay1",
    overlayPosition: "center-right",
  },
  {
    animations: ["show-pointer"],
    content: "day",
    highlight: ".DayView[data-day-id='6'] .hour-12",
    name: "timelineDay2",
    overlayPosition: "bottom-right",
  },
  {
    action: {
      action: "click",
      selector: ".DayView[data-day-id='6'] .DetailsToggle",
    },
    animations: [
      "show-action-click",
    ],
    content: "day",
    name: "timelineDay3",
    overlayPosition: "center-right",
  },
  {
    animations: [
      "scroll-to-highlight",
    ],
    content: "day-day",
    highlight: ".DayView[data-day-id='6'] .DayView-content .TabBar-tab:nth-child(1)",
    name: "timelineDay4",
    overlayPosition: "bottom-right",
  },
  {
    content: "day-stats",
    highlight: ".DayView[data-day-id='6'] .DayView-content .TabBar-tab:nth-child(2)",
    name: "timelineDay5",
    overlayPosition: "bottom-right",
  },
  {
    content: "day-journal",
    highlight: ".DayView[data-day-id='6'] .DayView-content .TabBar-tab:nth-child(5)",
    name: "timelineDay6",
    overlayPosition: "bottom-right",
  },
  {
    action: {
      action: "click",
      selector: ".DayView[data-day-id='6'] .DetailsToggle",
    },
    animations: [
      "show-action-click",
    ],
    content: "day-journal",
    name: "timelineDay7",
    overlayPosition: "bottom-right",
  },
  {
    content: "day",
    name: "timelineLog1",
    overlayPosition: "bottom-right",
  },

  {
    animations: ["scroll-highlight-top-slow"],
    content: "day",
    highlight: ".DayView[data-day-id='6'] .DayView-logs-log[data-log-id='23'] .LogView",
    name: "timelineLog2",
    overlayPosition: "bottom-right",
  },
  {
    action: {
      action: "click",
      selector: ".DayView[data-day-id='6'] .DayView-logs-log[data-log-id='23']",
    },
    animations: [
      "show-action-click",
    ],
    content: "day",
    highlight: ".DayView[data-day-id='6'] .DayView-logs-log[data-log-id='23']  .LogView",
    name: "timelineLog3",
    overlayPosition: "bottom-right",
  },

  {
    animations: ["scroll-to-highlight"],
    content: "log-navigation",
    highlight: ".DayView[data-day-id='6'] .DayView-logs-log[data-log-id='23'] .LogView-container .TabBar .TabBar-tabs .TabBar-tab:nth-child(1)",
    name: "timelineLog4",
    overlayPosition: "bottom-right",
  },
  {
    content: "log-environment",
    highlight: ".DayView[data-day-id='6'] .DayView-logs-log[data-log-id='23'] .LogView-container .TabBar .TabBar-tabs .TabBar-tab:nth-child(2)",
    name: "timelineLog5",
    overlayPosition: "bottom-right",
  },
  {
    animations: ["fade-out-content"],
    content: "day",
    name: "final1",
    overlayPosition: "center",
  },

  // End screen with buttons to other screencasts
  {
    animations: ["fade-in-content"],
    content: "end",
    name: "final2",
    overlayPosition: "bottom-center",
  },
];

export function ConceptSceneView({ onClose }: ConceptSceneViewProps) {
  return <SceneView onClose={onClose} frames={conceptFrames} />;
}
